(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kc-content-page"] && !Shopify.designMode) return;
  try {
    
  /* Password gate: client-side only (same as the old theme), so it hides the
     link from casual visitors but is not real security. Unlocks for the
     browser session, or straight away with ?pw=<password> in the URL. */
  document.querySelectorAll('[data-kc-gate]').forEach(function (gate) {
    var password = gate.dataset.kcGate;
    var key = 'kc-gate-unlocked';
    var form = gate.querySelector('form');
    var link = gate.querySelector('a');

    function unlock() {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      form.hidden = true;
      link.hidden = false;
    }

    var stored = false;
    try { stored = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (stored || new URLSearchParams(location.search).get('pw') === password) {
      unlock();
      return;
    }

    form.hidden = false;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.querySelector('input').value.trim() === password) {
        if (location.search.indexOf('pw=') > -1) history.replaceState({}, '', location.pathname);
        unlock();
      } else {
        form.querySelector('.kc-content-page__gate-error').hidden = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-kc-header]');
    if (!header) return;

    const body = document.body;
    const toggle = header.querySelector('.mobile-nav-toggle');
    const wrapper = document.getElementById('kc-mobile-nav');

    // Sticky header after 100px, as on the old site. Horizon scrolls
    // .page-wrapper on desktop and the window on mobile, so watch both.
    const pageWrapper = document.querySelector('.page-wrapper');
    const scrollTop = () => Math.max(window.scrollY, pageWrapper ? pageWrapper.scrollTop : 0);
    const updateStuck = () => {
      if (body.classList.contains('kc-nav-open')) return;
      body.classList.toggle('stuck-header', scrollTop() > 100);
    };
    updateStuck();
    window.addEventListener('scroll', updateStuck, { passive: true });
    pageWrapper?.addEventListener('scroll', updateStuck, { passive: true });

    if (!toggle || !wrapper) return;

    const closeNav = () => {
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      wrapper.classList.remove('open');
      header.classList.remove('mobile-nav-open');
      body.classList.remove('kc-nav-open');
      setTimeout(() => wrapper.classList.remove('opening'), 250);
      updateStuck();
    };

    const openNav = () => {
      body.classList.remove('stuck-header');
      body.classList.add('kc-nav-open');
      wrapper.classList.add('opening');
      header.classList.add('mobile-nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => {
        toggle.classList.add('open');
        wrapper.classList.add('open');
      });
    };

    toggle.addEventListener('click', () => {
      wrapper.classList.contains('opening') ? closeNav() : openNav();
    });

    wrapper.querySelectorAll('a.parent.with-children').forEach((parent) => {
      parent.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = parent.classList.contains('drop-open');
        wrapper.querySelectorAll('a.parent.with-children').forEach((other) => {
          other.classList.remove('drop-open');
          other.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          parent.classList.add('drop-open');
          parent.setAttribute('aria-expanded', 'true');
        }
      });
    });

    wrapper.querySelectorAll('a:not(.parent.with-children)').forEach((link) => {
      link.addEventListener('click', closeNav);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-modal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const modalFor = (hash) => {
      if (!hash || hash.length < 2) return null;
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      return el && el.matches('dialog.kc-modal') ? el : null;
    };

    const open = (dialog) => {
      if (!dialog.open) dialog.showModal();
    };

    // Links to #<Modal ID> open the modal instead of jumping.
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (link && link.pathname === location.pathname) {
        const dialog = modalFor(link.hash);
        if (dialog) {
          event.preventDefault();
          open(dialog);
          return;
        }
      }

      // Close button, or a click on the backdrop (outside the frame, not its padding).
      const dialog = event.target.closest('dialog.kc-modal');
      if (!dialog) return;
      if (event.target.closest('[data-kc-modal-close]')) {
        dialog.close();
      } else if (event.target === dialog) {
        const r = dialog.getBoundingClientRect();
        const outside = event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
        if (outside) dialog.close();
      }
    });

    // A link from another page (e.g. /pages/offerings#inquire-private-workshops) opens it on arrival.
    const fromUrl = modalFor(location.hash);
    if (fromUrl) open(fromUrl);

    // Theme editor: show the modal while its section is selected.
    document.addEventListener('shopify:section:select', (event) => {
      const dialog = event.target.querySelector('dialog.kc-modal');
      if (dialog) open(dialog);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      const dialog = event.target.querySelector('dialog.kc-modal');
      if (dialog) dialog.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-workshop"]) return;
  try {
    
  document.querySelectorAll('[data-kc-workshop-form]').forEach((form) => {
    const price = form.querySelector('[data-kc-price]');
    const note = form.querySelector('[data-kc-note]');
    form.addEventListener('change', (event) => {
      if (event.target.dataset.price) price.textContent = event.target.dataset.price;
      if (note && 'note' in event.target.dataset) {
        note.textContent = event.target.dataset.note;
        note.hidden = !event.target.dataset.note;
      }
    });

    // Show the focus ring on the option boxes for keyboard use only, not after a click.
    form.addEventListener('pointerdown', () => form.classList.add('kc-pointer'));
    form.addEventListener('keydown', () => form.classList.remove('kc-pointer'));

    // Application workshops: Apply reveals the app-block form; a submitted
    // Globo form sends the selected option straight to checkout.
    const apply = form.querySelector('[data-kc-apply]');
    const application = apply && document.getElementById(apply.getAttribute('aria-controls'));
    if (!application) return;

    // Copy the selected option's name into the Globo hidden field ("Payment option"),
    // so the submission shows which option the applicant chose.
    const setOption = () => {
      const selected = form.querySelector('input[name="id"]:checked');
      const field = application.querySelector('input[name="hidden-1"]');
      if (!selected || !selected.dataset.title || !field) return;
      field.value = selected.dataset.title;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    };
    form.addEventListener('change', setOption);

    apply.addEventListener('click', () => {
      setOption();
      application.hidden = false;
      apply.hidden = true;
      apply.setAttribute('aria-expanded', 'true');
      const field = application.querySelector('input, select, textarea');
      if (field) field.focus();
    });

    document.addEventListener('globo.formbuilder.form.submitted', (event) => {
      const submitted = event.detail && event.detail.form;
      if (submitted instanceof Element && !application.contains(submitted)) return;

      const variant = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!variant) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = `${root}cart/${variant.value}:1`;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
